class HttpError extends Error {
    constructor(message, name, status) {
        super(message);
        this.name = name;
        this.status = status;
        this.statusCode = status;
    }
}
export { HttpError };
